import { CanceledContractListPage } from "@/features/rso/pages/CanceledContractList";
import React from "react";

const CanceledContractList = () => {
  return <CanceledContractListPage />;
};

export default CanceledContractList;
